var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var MenuDivider = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border: 1px solid ", ";\n"], ["\n  width: 100%;\n  border: 1px solid ", ";\n"])), function (props) { return props.theme.colors.border.base; });
var templateObject_1;
